import effraLightWoff from '../../assets/fonts/Effra-Light.woff';
import effraLightWoff2 from '../../assets/fonts/Effra-Light.woff2';
import effraMediumWoff from '../../assets/fonts/Effra-Medium.woff';
import effraMediumWoff2 from '../../assets/fonts/Effra-Medium.woff2';
import effraRegularWoff from '../../assets/fonts/Effra-Regular.woff';
import effraRegularWoff2 from '../../assets/fonts/Effra-Regular.woff2';
import icomoon from './icomoon';

export default `
  @font-face {
    font-family: 'effra';
    src: url(${effraLightWoff}) format('woff'),
      url(${effraLightWoff2}) format('woff2');
    font-weight: 300;
    font-style: normal;
  }
  @font-face {
    font-family: 'effra';
    src: url(${effraMediumWoff}) format('woff'),
      url(${effraMediumWoff2}) format('woff2');
    font-weight: 500;
    font-style: normal;
  }
  @font-face {
    font-family: 'effra';
    src: url(${effraRegularWoff}) format('woff'),
      url(${effraRegularWoff2}) format('woff2');
    font-weight: 400;
    font-style: normal;
  }

  ${icomoon}
`;
